<div>
         <div class="pt-5 mx-auto">
            <h1 class="pb-2 border-bottom fw-light" i18n>Über uns</h1>

            <div>
               <h2 i18n>Mission und Vision</h2>
            </div>
            <div i18n>Mach direkt zu Beginn klar, wofür dein Unternehmen steht. Mit welchem Ziel kam es zur Gründung? Welchen
               positiven
               Beitrag will dein Unternehmen für Kunden oder die Gesellschaft leisten? Erzähle keinen Roman, sondern
               formuliere in
               einem oder zwei Sätzen ein Mission Statement. Damit kann der Nutzer schnell herausfinden, ob er
               grundsätzlich an der für
               ihn richtigen Adresse ist.
            </div>
            <br>

            <div>
               <h2 i18n>Leistungen und Produkte</h2>
            </div>
            <div i18n>Ja, auf der Über-uns-Seite geht es nicht um dein Angebot, sondern dein Unternehmen. Manchmal kann es
               zum
               Verständnis des
               Alleinstellungsmerkmals jedoch sinnvoll sein, kurz das Geschäftsmodell zu umreißen oder auf die
               Besonderheiten der
               Produkte einzugehen.
            </div>
            <br>

            <div>
               <h2 i18n>Das Team</h2>
            </div>
            <div i18n>Kunden wollen wissen, welche Menschen hinter einer innovativen Idee oder Unternehmensgründung stehen
               und
               Bewerber haben
               weniger Hemmungen Kontakt aufzunehmen, wenn sie einem Ansprechpartner mit Namen und Gesicht schreiben
               können. Selbst
               wenn diese Prozesse oft unbewusst ablaufen, wirken sie dennoch.
            </div>
            <br>

            <div i18n>Stellt euch deshalb als Team mit Foto, Jobbezeichnung und – wenn sinnvoll – Kontaktmöglichkeit vor. Ab
               einer gewissen
               Teamgröße müssen nicht alle Mitarbeiter aufgeführt werden. Das würde den Rahmen sprengen, konzentiere
               dich
               auf die
               Schlüsselpositionen. Ein Teamfoto kann in dem Fall als Hero Image zu Beginn der Seite stehen.</div>
            <br>

            <div>
               <h2 i18n>Testimonials und Kundenstimmen</h2>
            </div>
            <div i18n>Stimmen zufriedener Kunden, Auszeichnungen und Zertifizierungen unterstreichen die Glaubwürdigkeit
               deines
               Unternehmens.
               Statt die eigenen Erfolge unbelegt und überschwänglich zu betonen, erreichst du mehr, wenn du an
               verschiedenen Stellen
               auf der Über-uns-Seite positive Rückmeldungen Dritter integrierst.
            </div>
            <br>

            <div>
               <h2 i18n>Die Unternehmensgeschichte</h2>
            </div>
            <div i18n>Ob als Fließtext, Video oder als Infografik: Die Geschichte deines Unternehmens sollte auf keiner
               Über-uns-Seite fehlen.
               Sie gibt dir die Möglichkeit, von Erfolgen deiner Firma zu berichten und damit das Vertrauen der
               Website-Besucher zu
               stärken, aber sie kann auch Werte und die Resilienz deines Unternehmens betonen und zusätzliche
               Sympathiepunkte bringen.
               6. Möglichkeit zur Kontaktaufnahme
            </div>
            <br>

            <div i18n>Manche Unternehmen verzichten darauf, den Nutzer auf ihrer Über-uns-Seite zur Kontaktaufnahme zu
               motivieren. Wenn du
               keinen wirklich guten Grund dafür findest (meist gibt es ihn nicht): Platziere zumindest am Ende der
               Seite
               einen Call to
               Action. Wer bis hierhin gekommen ist, ist bereit für den nächsten Schritt in der Customer oder Bewerber
               Journey.
            </div>
            <br>

            <div i18n>Manche Unternehmen setzen dagegen großzügig auf Buttons und Text-Links zu Produktseiten,
               Newsletter-Anmeldungen und
               Webinaren. Zu viele Optionen bergen allerdings die Gefahr, dass der Nutzer sich belästigt oder
               überfordert
               fühlt und
               sich für keinen Klick entscheidet.
            </div>
            <br>

         </div>

</div>